module.exports = {
  emptyMessage: 'نسيت ملء رقم بطاقتك',
  defaultMessage: 'نسيت ملء رقم بطاقتك',
};
